import React from 'react';
import styled from 'styled-components';
import { Points } from '@styles';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { useTranslations } from '@libs/translations';

export const B2BInfrastructure = () => {
  const translations = useTranslations();

  return (
    <View>
      <Top>
        <Title>{translations.t('site.home.b2b.infrastructure.title')}</Title>
        <Text>{translations.t('site.home.b2b.infrastructure.text')}</Text>
      </Top>
      <Picture>
        <source srcSet="/images/home/b2b/infrastructure.webp" type="image/webp" />
        <Img src="/images/home/b2b/infrastructure.png" alt="" />
      </Picture>
    </View>
  );
};

const View = styled.div`
  background-color: ${Colors.main_black};
  color: ${Colors.white};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  border-radius: 20px;
  overflow: hidden;
  padding: 16px;
  flex-grow: 1;

  @media ${Points.tablet_portrait} {
    width: 50%;
    height: auto;
  }

  @media ${Points.tablet_landscape} {
    padding: 30px;
    width: 40%;
    min-width: 380px;
  }

  @media ${Points.laptop_wide} {
    padding: 40px;
  }
`;
const Top = styled.div`
  margin-bottom: 60px;

  @media ${Points.tablet_landscape} {
    margin-bottom: 30px;
  }

  @media ${Points.laptop_wide} {
    font-size: 63px;
  }
`;
const Title = styled.div`
  font-size: 18px;
  line-height: 1.1;
  margin-bottom: 10px;

  @media ${Points.tablet_landscape} {
    font-size: 20px;
    margin-bottom: 15px;
  }

  @media ${Points.laptop_wide} {
    font-size: 24px;
    margin-bottom: 20px;
  }
`;
const Text = styled.div`
  font-size: 14px;
  line-height: 1.3;
  max-width: 510px;

  @media ${Points.tablet_landscape} {
    font-size: 16px;
    max-width: none;
  }

  @media ${Points.laptop_wide} {
    font-size: 18px;
  }
`;
const Picture = styled.picture`
  height: 175px;
  width: 100%;
  object-fit: contain;

  @media ${Points.tablet_landscape} {
    height: 175px;
  }
`;
const Img = styled.img`
  height: 175px;
  width: 100%;
  object-fit: contain;

  @media ${Points.tablet_landscape} {
    height: 175px;
  }
`;
